import * as React from "react";

import { Icon } from "../../../../Icons/Icon";

import { UnitAdderDisabled, UnitAdderRoot } from "./UnitAdder.styles";

export interface UnitAdderProps {
    onClick: () => void;
    unitName: string;
    text?: string;
    style?: React.CSSProperties;
    disableAppend?: boolean;
}

export function UnitAdder(props: UnitAdderProps): JSX.Element {
    if (props.disableAppend) {
        return (
            <UnitAdderDisabled style={props.style}>
                {props.text ?? (
                    <>
                        <Icon name="PlusIcon" /> Добавить {props.unitName}
                    </>
                )}
            </UnitAdderDisabled>
        );
    } else {
        return (
            <UnitAdderRoot onClick={props.onClick} style={props.style}>
                {props.text ?? (
                    <>
                        <Icon name="PlusIcon" /> Добавить {props.unitName}
                    </>
                )}
            </UnitAdderRoot>
        );
    }
}
